import { AxiosResponse } from "axios";
import { ElNotification } from "element-plus";

export const handleRequest = async <T>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  request: Promise<AxiosResponse<any>>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extractData: (data: any) => T
): Promise<T | null> => {
  try {
    const response = await request;
    return extractData(response.data);
  } catch (error: any) {
    if (!error.response) return null;
    const data = error.response.data || {};
    const title = data.message || data.code || "请求失败";
    const msg = data.info || error.message || "";
    ElNotification({
      title,
      message: msg,
      type: "error",
    });
    return null;
  }
};
